export default "__VITE_ASSET__BsOmCNS0__"